import Pioneros from "../../../resources/logos/clients/pioneros-mochis.png";
import Venados from "../../../resources/logos/clients/venados-mzt.png";
import Astros from "../../../resources/logos/clients/astros.png";
import PremierePadelCancunP2 from "../../../resources/logos/clients/padel-cancun-p2.png";
import UTSGdl from "../../../resources/logos/clients/uts-gdl.png";
import MexicoOpenVidanta from "../../../resources/logos/clients/mxopen-vidanta.png";
import WTAMerida from "../../../resources/logos/clients/wta-merida.png";
import WTAGdl from "../../../resources/logos/clients/wta-gdl.png";
import AbiertoGnp from "../../../resources/logos/clients/abierto-gnp.png";
import JardinesMexico from "../../../resources/logos/clients/jardines-mexico.png";
import PashMusicHall from "../../../resources/logos/clients/pash-music-hall.png";
import Soccerlife from "../../../resources/logos/clients/soccerlife.png";
import TeatroCavaret from "../../../resources/logos/clients/teatro-cavaret.png";
import AuditorioExplanada from "../../../resources/logos/clients/auditorio-explanada.png";
import Portamerica from "../../../resources/logos/clients/portamerica.png";
import Navidalia from "../../../resources/logos/clients/navidalia.png";
import Otonobierfest from "../../../resources/logos/clients/otonobierfest.png";
import FestivalChefSonora from "../../../resources/logos/clients/festival-chef-sonora.png";
import Dreamfields from "../../../resources/logos/clients/dreamfields.png";
import Calaverandia from "../../../resources/logos/clients/calaverandia.png";
import ClubPuebla from "../../../resources/logos/clients/club-puebla.png";
import VenadosFC from "../../../resources/logos/clients/venados-fc.png";
import TolucaFC from "../../../resources/logos/clients/toluca-fc.png";
import FCJuarez from "../../../resources/logos/clients/fc-juarez.png";
import AtleticoSanLuis from "../../../resources/logos/clients/atletico-san-luis.png";
import AlgodonerosGuasave from "../../../resources/logos/clients/algodoneros-guasave.png";
import JaguaresNayarit from "../../../resources/logos/clients/jaguares-nayarit.png";
import YaquisObregon from "../../../resources/logos/clients/yaquis-obregon.png";
import CalienteDurango from "../../../resources/logos/clients/caliente-durango.png";
import RielerosAguascalientes from "../../../resources/logos/clients/rieleros-ags.png";
import Tecos2Laredos from "../../../resources/logos/clients/tecos-2-laredos.png";
import Naranjeros from "../../../resources/logos/clients/naranjeros.png";
import GuerrerosOaxaca from "../../../resources/logos/clients/guerreros-oaxaca.png";
import TorosTijuana from "../../../resources/logos/clients/toros-tijuana.png";

export const clientLogos = [
  {
    src: Pioneros,
    alt: "Pioneros de Los Mochis logo",
  },
  {
    src: Venados,
    alt: "Venados de Mazatlán logo",
  },
  {
    src: Astros,
    alt: "Astros de Jalisco logo",
  },
  {
    src: PremierePadelCancunP2,
    alt: "Premiere Padel Cancún P2 logo",
  },
  {
    src: UTSGdl,
    alt: "Ultimate Tennis Showdown GDL logo",
  },
  {
    src: MexicoOpenVidanta,
    alt: "Mexico Open Vidantaworld logo",
  },
  {
    src: WTAMerida,
    alt: "WTA 250 Merida logo",
  },
  {
    src: WTAGdl,
    alt: "WTA 500 GDL logo",
  },
  {
    src: AbiertoGnp,
    alt: "Abierto GNP Seguros logo",
  },
  {
    src: JardinesMexico,
    alt: "Jardines de México logo",
  },
  {
    src: PashMusicHall,
    alt: "Pash Music Hall logo",
  },
  {
    src: Soccerlife,
    alt: "Soccerlife logo",
  },
  {
    src: TeatroCavaret,
    alt: "Teatro Estudio Cavaret logo",
  },
  {
    src: AuditorioExplanada,
    alt: "Auditorio Explanada logo",
  },
  {
    src: Portamerica,
    alt: "PortAmérica logo",
  },
  {
    src: Navidalia,
    alt: "Navidalia logo",
  },
  {
    src: Otonobierfest,
    alt: "OtoñoBierfest logo",
  },
  {
    src: FestivalChefSonora,
    alt: "Festival del Chef Sonora logo",
  },
  {
    src: Dreamfields,
    alt: "Dreamfields logo",
  },
  {
    src: Calaverandia,
    alt: "Calaverandia logo",
  },
  {
    src: ClubPuebla,
    alt: "Club Puebla logo",
  },
  {
    src: VenadosFC,
    alt: "Venados FC logo",
  },
  {
    src: TolucaFC,
    alt: "Toluca FC logo",
  },
  {
    src: FCJuarez,
    alt: "FC Juárez logo",
  },
  {
    src: AtleticoSanLuis,
    alt: "Atlético San Luis logo",
  },
  {
    src: AlgodonerosGuasave,
    alt: "Algodoneros de Guasave logo",
  },
  {
    src: JaguaresNayarit,
    alt: "Jaguares de Nayarit logo",
  },
  {
    src: YaquisObregon,
    alt: "Yaquis de Obregón logo",
  },
  {
    src: CalienteDurango,
    alt: "Caliente Durango logo",
  },
  {
    src: RielerosAguascalientes,
    alt: "Rieleros de Aguascalientes logo",
  },
  {
    src: Tecos2Laredos,
    alt: "Tecos 2 Laredos logo",
  },
  {
    src: Naranjeros,
    alt: "Naranjeros de Hermosillo logo",
  },
  {
    src: GuerrerosOaxaca,
    alt: "Guerreros de Oaxaca logo",
  },
  {
    src: TorosTijuana,
    alt: "Toros de Tijuana logo",
  },
];
